import useRejectReasonBaseActions from './useRejectReasonBaseActions'

export default useRejectReasonBaseActions
